module.exports = __webpack_public_path__ + "static/img/star-small.4c67f20a.png";